<template>
  <div>
    <el-card>
      <div slot="header" style="display:flex;justify-content:space-between;align-items:center;">
        <span>选题公示</span>
        <div>
          <el-button type="primary" size="mini" @click="getlist">刷新</el-button>
        </div>
      </div>

      <el-table
        :data="itemlist"
        stripe
        style="width:100%; table-layout:fixed;"
        @row-dblclick="edit"
        size="small"
        border
      >
        <el-table-column prop="siid" label="编号" width="90"></el-table-column>

        <el-table-column prop="title" label="选题名称" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ scope.row.title }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="mid" label="专业" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ scope.row.mid }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="ctdate" label="出题时间" width="160"></el-table-column>

        <el-table-column
          prop="tidesc"
          label="选题描述"
          min-width="360"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="max-height:72px; overflow:hidden; text-overflow:ellipsis; white-space:normal; line-height:1.2;">
              {{ scope.row.tidesc }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="checktype" label="审核状态" width="120">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.checktype"
              :type="scope.row.checktype === '已通过' ? 'success' : (scope.row.checktype === '已驳回' ? 'danger' : 'info')">
              {{ scope.row.checktype }}
            </el-tag>
            <span v-else>未审核</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="260" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="edit(scope.row)">编辑</el-button>

            <!-- 已通过：显示驳回 -->
            <el-button
              v-if="isPassed(scope.row)"
              type="danger"
              size="mini"
              @click="actionReject(scope.row)">
              驳回
            </el-button>

            <!-- 已驳回：显示审核（通过） -->
            <el-button
              v-else-if="isRejected(scope.row)"
              type="success"
              size="mini"
              @click="actionApprove(scope.row)">
              审核
            </el-button>

            <!-- 其他（未审核等）：显示通过与驳回 -->
            <span v-else>
              <el-button type="primary" size="mini" @click="actionApprove(scope.row)">通过</el-button>
              <el-button type="danger" size="mini" @click="actionReject(scope.row)">驳回</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑 / 审核 对话框 -->
    <el-dialog title="选题信息" v-model="dialogFormVisible" :show-close="false" width="80%">
      <el-form label-width="100px" :model="itemedit">
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="出题时间">
              <el-date-picker v-model="itemedit.ctdate" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业名称">
              <el-select v-model="itemedit.mid" placeholder="请选择专业" @change="selectmajor">
                <el-option v-for="m in majors" :key="m.mid" :label="m.name" :value="m.mid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年份">
              <el-input v-model="itemedit.yy" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="选题名称">
              <el-input v-model="itemedit.title"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="选题描述">
              <el-input type="textarea" :rows="6" v-model="itemedit.tidesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="postdata(true)">通过</el-button>
        <el-button type="danger" @click="postdata(false)">驳回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemlist: [],
      itemedit: {},
      dialogFormVisible: false,
      majors: [],
      pars: { objname: 'sys_title' },
      currentPage: 1,
      pagesize: 20,
      querykey: ''
    };
  },
  created() {
    this.getlist();
    this.getMajors();
  },
  methods: {
    isPassed(row) {
      const ct = (row && row.checktype) ? String(row.checktype).trim() : '';
      return ct === '已通过' || ct.toLowerCase() === 'passed' || ct === '通过';
    },
    isRejected(row) {
      const ct = (row && row.checktype) ? String(row.checktype).trim() : '';
      return ct === '已驳回' || ct.toLowerCase() === 'rejected' || ct === '驳回';
    },

    // 获取列表
    getlist() {
      const that = this;
      that.GetData('Common/GETLIST', { objname: 'sys_title', page: that.currentPage, pagesize: that.pagesize, querykey: that.querykey }, res => {
        try {
          const rows = (res.data && res.data.data && res.data.data.rows) ? res.data.data.rows : [];
          that.itemlist = rows.map(r => {
            const checktype = (r.checktype || r.CHECKTYPE || r.checkType || r.check_type || '').toString().trim() || '未审核';
            return {
              siid: r.siid || r.SIID,
              title: r.title || r.TITLE || '',
              mid: r.mid || r.MID || '',
              ctdate: r.ctdate || r.CTDATE || '',
              tidesc: r.tidesc || r.TIDESC || '',
              yy: r.yy || r.YY || '',
              checktype: checktype
            };
          });
        } catch (e) {
          that.itemlist = [];
          console.warn('getlist parse error', e);
        }
      }, err => {
        console.warn('getlist error', err);
        that.itemlist = [];
        if (that.$message) that.$message.error('获取列表失败');
      });
    },

    // 打开编辑对话框
    edit(row) {
      const source = row && row.siid ? row : (row ? row.row : null);
      if (source && source.siid) {
        this.itemedit = Object.assign({}, source);
      } else {
        this.itemedit = { ctdate: '', mid: '', yy: '', title: '', tidesc: '' };
      }
      this.openDialog();
    },

    openDialog() {
      this.dialogFormVisible = true;
    },
    closeDialog() {
      this.dialogFormVisible = false;
    },

    // 获取专业列表
    getMajors() {
      const that = this;
      that.GetData('Common/GETMAJORS', {}, res => {
        try {
          const arr = (res.data && res.data.data) ? res.data.data : [];
          that.majors = arr.map(a => ({ mid: a.mid || a.MID, name: a.name || a.NAME }));
        } catch (e) {
          that.majors = [];
          console.warn('getMajors parse error', e);
        }
      }, err => {
        that.majors = [];
        console.warn('getMajors error', err);
        if (that.$message) that.$message.error('获取专业列表失败');
      });
    },

    selectmajor(e) {
      // 可执行联动逻辑
    },

    // 行为封装：先设置 itemedit 为目标行，再调用 postdata
    actionApprove(row) {
      this.itemedit = Object.assign({}, row);
      this.postdata(true);
    },
    actionReject(row) {
      this.itemedit = Object.assign({}, row);
      this.postdata(false);
    },

    // 审核（通过 / 驳回）
    postdata(state) {
      const that = this;
      let messtext = '';
      let checktype = '已通过';
      if (state) {
        messtext = '确定要通过此选题吗？';
        checktype = '已通过';
      } else {
        messtext = '确定要驳回此选题吗？';
        checktype = '已驳回';
      }

      that.$confirm(messtext, '询问', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const pars = {
          objname: 'sys_title',
          keyfield: 'siid',
          keyvalue: that.itemedit.siid,
          fields: {
            checktype: checktype,
            checkdate: that.FormatDate(new Date())
          }
        };
        that.PostData('Common/UPDATE', pars, (res) => {
          for (let i = 0; i < that.itemlist.length; i++) {
            if (that.itemlist[i].siid === that.itemedit.siid) {
              that.itemlist[i].checktype = checktype;
              break;
            }
          }
          that.dialogFormVisible = false;
          that.getlist();
          if (that.$message) that.$message.success('操作成功');
        }, (err) => {
          console.warn('postdata error', err);
          if (that.$message) that.$message.error(typeof err === 'string' ? err : '操作失败');
        });
      }).catch(() => {
        // 取消，不提示
      });
    },

    // 常用工具：格式化日期为 yyyy-MM-dd HH:mm:ss
    FormatDate(d) {
      try {
        const dt = new Date(d);
        const pad = (n) => (n < 10 ? '0' + n : n);
        return dt.getFullYear() + '-' + pad(dt.getMonth() + 1) + '-' + pad(dt.getDate()) + ' ' + pad(dt.getHours()) + ':' + pad(dt.getMinutes()) + ':' + pad(dt.getSeconds());
      } catch (e) {
        return '';
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>